<template>
  <div class="material-select">
    <popup
      ref="popupRef"
      width="750px"
      custom-class="select-file-dialog"
      :title="`选择${tipsText}`"
      @confirm="handleConfirm"
      @close="handleClose"
      :async="Boolean(sizeLimit || proportionLimit)"
    >
      <template v-if="!hiddenUpload" v-slot:trigger>
        <div class="material-select__trigger clearfix" @click.stop>
          <draggable
            v-if="needShowSelect"
            v-model="fileList"
            class="draggable"
            animation="300"
            item-key="id"
          >
            <template>
              <div
                v-for="(element, index) in fileList"
                :key="element.id"
                class="material-preview"
                :class="{
                  'is-disabled': disabled,
                  'is-one': limit == 1,
                }"
                @click="showPopup(index)"
              >
                <del-wrap @close="deleteImg(index)">
                  <file-item
                    :uri="element.url + '?imageView2/0/w/200/h/0/q/100'"
                    :type="type"
                    :width="size.width"
                    :height="size.height"
                    :fit="'cover'"
                  />
                </del-wrap>
                <div class="operation-btns text-xs text-center">
                  <span>修改</span> |
                  <span @click.stop="handlePreview(element.url)">查看</span>
                </div>
              </div>
              <div v-if="!showUpload" class="tips form-item__tips">
                <template v-if="tips">{{ tips }}</template>
                <div v-if="tipsHtml" v-html="tipsHtml" />
              </div>
            </template>
          </draggable>
          <div
            v-show="showUpload || !needShowSelect"
            class="material-upload"
            :class="{
              'is-disabled': disabled,
              'is-one': limit == 1,
              [uploadClass]: true,
            }"
            @click="showPopup(-1)"
          >
            <slot name="upload">
              <div
                class="upload-btn"
                :style="{ width: size.width, height: size.height }"
              >
                <i class="el-icon-plus" />
                <span>{{ addButtonText }}</span>
              </div>
              <div class="tips form-item__tips">
                <template v-if="tips">{{ tips }}</template>
                <div v-if="tipsHtml" v-html="tipsHtml" />
              </div>
            </slot>
          </div>
        </div>
      </template>
      <div class="material-wrap">
        <material
          v-if="materialVisible"
          ref="materialRef"
          :type="type"
          :file-size="fileSize"
          :limit="meterialLimit"
          :is-admin="isAdmin"
          :visible="materialVisible"
          :forbid-select="forbidSelect"
          @change="selectChange"
        />
      </div>
    </popup>
    <preview v-model="showPreview" :url="previewUrl" :type="type" />
  </div>
</template>

<script>
import Draggable from "vuedraggable";
import Popup from "../popup/index.vue";
import FileItem from "./file.vue";
import Material from "./content.vue";
import Preview from "./preview.vue";
import DelWrap from "../DelWrap/index.vue";
export default {
  components: {
    Popup,
    Draggable,
    FileItem,
    Material,
    Preview,
    DelWrap,
  },
  props: {
    needShowSelect: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [String, Array, Number],
      default: () => [],
    },
    // 文件类型 image/video/
    type: {
      type: String,
      default: "image",
    },
    // 文件尺寸
    fileSize: {
      type: String,
      default: "100px",
    },
    // 选择数量限制
    limit: {
      type: Number,
      default: 1,
    },
    //大小限制
    sizeLimit: {
      type: Number,
      default: 0, //M
    },
    //比例限制
    proportionLimit: {
      type: String,
      default: "",
    },
    // 禁用选择
    disabled: {
      type: Boolean,
      default: false,
    },
    // 隐藏上传框*(目前在富文本中使用到)
    hiddenUpload: {
      type: Boolean,
      default: false,
    },
    uploadClass: {
      type: String,
      default: "",
    },
    // 选择器尺寸
    size: {
      type: Object,
      default: () => {
        return {
          width: "240px",
          height: "135px",
        };
      },
    },
    // 提示信息 文本
    tips: {
      type: String,
      default: "",
    },
    // 提示信息 html
    tipsHtml: {
      type: String,
      default: "",
    },
    //  禁止选中的文件
    forbidSelect: {
      type: Array,
      default: () => [],
    },
    // 添加按钮文案
    addButtonText: {
      type: String,
      default: "添加",
    },
  },
  data() {
    return {
      popupRef: null,
      materialRef: null,
      previewUrl: "",
      showPreview: false,
      // 选中的文件
      fileList: [],
      select: [],
      isAdd: true,
      currentIndex: -1,
      materialVisible: false,
    };
  },
  computed: {
    tipsText() {
      switch (this.type) {
        case "image":
          return "图片";
        case "video":
          return "视频";
        case "file":
          return "文档";
        default:
          return "";
      }
    },
    showUpload() {
      return this.limit - this.fileList.length > 0;
    },
    meterialLimit() {
      if (!this.isAdd) {
        return 1;
      }
      if (this.limit === -1) return null;
      return this.limit - this.fileList.length;
    },
    isAdmin() {
      return this.$store.getters.app === "admin";
    },
  },
  watch: {
    value: {
      handler(newVal) {
        const val = JSON.parse(JSON.stringify(newVal));
        if (Array.isArray(val)) {
          this.fileList = val.map((item) => {
            return {
              url: item,
            };
          });
        } else if (val) {
          this.fileList = [
            {
              url: val,
            },
          ];
        } else {
          this.fileList = [];
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleConfirm() {
      const select = this.select;
      if (!this.isAdd) {
        // 如果不是新增，去select第一条数据插进去
        this.fileList.splice(this.currentIndex, 1, select.shift());
      } else {
        this.fileList = [...this.fileList, ...select];
      }
      this.handleChange();
    },
    showPopup(index) {
      if (this.disabled) return;
      if (index >= 0) {
        this.isAdd = false;
        this.currentIndex = index;
      } else {
        this.isAdd = true;
      }
      this.select = [];
      if (!this.needShowSelect) {
        this.fileList = [];
      }
      this.$refs["popupRef"].open();
      this.materialVisible = true;
    },
    selectChange(val) {
      this.select = val;
    },
    handleChange() {
      const valueImg =
        this.limit !== 1 ? this.fileList : this.fileList[0] || "";
      let returnValue = "";
      if (this.limit !== 1) {
        returnValue = valueImg.map((item) => item.url);
      } else {
        returnValue = valueImg.url;
      }
      // 大小和比例限制
      if (this.sizeLimit) {
        const res = this.fileList.every((item) => {
          if (item.file_size > this.sizeLimit * 1024 * 1024) {
            return false;
          } else {
            return true;
          }
        });

        if (!res) {
          this.$message.error("文件大小不能超过" + this.sizeLimit + "M");
          this.fileList = [];
          return;
        }
      }
      if (this.proportionLimit) {
        const res = this.fileList.every((item) => {
          if (
            this.getAspectRatio(item.img_width, item.img_height) !==
            this.proportionLimit
          ) {
            return false;
          } else {
            return true;
          }
        });
        if (!res) {
          this.$message.error("文件比例必须为" + this.proportionLimit);
          this.fileList = [];
          return;
        }
      }

      this.$emit("change", this.fileList);
      this.$emit("input", returnValue);
      this.$emit("confirm", this.fileList);
      if (this.$parent?.elForm) {
        this.$parent.$emit("el.form.change");
      }
      this.handleClose();
    },
    // 获取文件宽高比例
    getAspectRatio(width, height) {
      // 计算最大公约数
      function gcd(a, b) {
        return b === 0 ? a : gcd(b, a % b);
      }

      // 确保宽高为正数
      width = Math.abs(width);
      height = Math.abs(height);

      // 计算最大公约数
      const divisor = gcd(width, height);

      // 计算比例
      const ratioX = Math.round(width / divisor);
      const ratioY = Math.round(height / divisor);

      // 返回比例字符串
      return `${ratioX}:${ratioY}`;
    },
    deleteImg(index) {
      this.fileList.splice(index, 1);
      this.handleChange();
    },
    handlePreview(url) {
      console.log(url);
      this.previewUrl = url;
      this.showPreview = true;
    },
    handleClose() {
      this.materialVisible = false;
      this.$nextTick(() => {
        if (this.hiddenUpload) this.fileList = [];
        this.$refs["materialRef"]?.clearSelect();
      });
      if (this.sizeLimit || this.proportionLimit) {
        this.$refs["popupRef"].visible = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.material-select {
  .draggable {
    display: flex;
    align-items: flex-end;
  }
  .material-upload,
  .material-preview {
    position: relative;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: 8px;
    box-sizing: border-box;
    float: left;
    &.is-disabled {
      cursor: not-allowed;
    }
    &.is-one {
      margin-bottom: 0;
    }
    &:hover {
      .operation-btns {
        display: block;
      }
    }
    .operation-btns {
      display: none;
      position: absolute;
      bottom: 0;
      border-radius: 4px;
      width: 100%;
      line-height: 2;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
  .material-upload {
    display: flex;
    align-items: flex-end;
    .upload-btn {
      width: 240px;
      height: 135px;
      background: #f5f5f5;
      color: var(--el-text-color-tips);
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      i {
        font-size: 16px;
      }
      span {
        margin-top: 10px;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 17px;
      }
    }
  }
}
.tips {
  color: var(--el-text-color-tips);
  font-size: 12px;
  line-height: 20px;
  margin-left: 12px;
  float: left;
  max-width: 300px;
}
.material-wrap {
  height: 430px;
  margin: 0;
}
</style>
<style lang="scss">
.select-file-dialog {
  --select-file-dialog-bg: #f3f5f7;
  --select-file-surface-bg: #f9fafb;
  --select-file-text: #0d1400;
  --select-file-secondary: #515350;
  --select-file-border: #e1e2e5;
  --select-file-control-bg: #ffffff;
  --select-file-control-hover-bg: #f3f5f7;
  --select-file-control-active-bg: #ffffff;
  --select-file-table-header-bg: #f3f5f7;
  --select-file-pagination-bg: transparent;
  --select-file-muted: rgba(0, 0, 0, 0.35);

  margin-top: calc(50vh - 280px) !important;
  background-color: var(--select-file-dialog-bg);
  border-radius: 24px;
  .el-dialog__header {
    padding: 20px 24px;
    font-weight: 500;
    font-size: 16px;
    color: var(--select-file-text);
    line-height: 22px;
  }
  .el-dialog__body {
    padding: 0 24px;
    .material-wrap {
      overflow: hidden;
      margin: 0;
      height: 420px;
      background: var(--select-file-surface-bg);
      border-radius: 12px;
      border: 1px solid var(--select-file-border);
      background-color: var(--select-file-surface-bg);
    }
  }

  .material-content,
  .el-table,
  .el-table tr,
  .el-table th,
  .el-table td {
    background: var(--select-file-surface-bg);
    color: var(--select-file-text);
  }

  .el-button--small:not(.el-button--primary),
  .select-name {
    background: var(--select-file-control-bg);
    border-color: var(--select-file-border);
    color: var(--select-file-text);
  }

  .el-table__empty-text,
  .form-item__tips,
  .tips {
    color: var(--select-file-secondary);
  }
}

html.dark .select-file-dialog {
  --select-file-dialog-bg: var(--mg-bg-elevated);
  --select-file-surface-bg: var(--mg-bg-card);
  --select-file-text: var(--mg-text-primary);
  --select-file-secondary: var(--mg-text-secondary);
  --select-file-border: var(--mg-border-subtle);
  --select-file-control-bg: var(--mg-control-bg);
  --select-file-control-hover-bg: var(--mg-control-hover-bg);
  --select-file-control-active-bg: var(--mg-bg-surface);
  --select-file-table-header-bg: var(--mg-bg-surface);
  --select-file-pagination-bg: var(--mg-bg-surface);
  --select-file-muted: var(--mg-text-muted);
}
</style>
